module.exports = __webpack_public_path__ + "static/media/iPhone14-3.5ad0f5f7.png";